<template>
    <div class="page">
        <div class="header">
            <Header :current="['sn']"></Header>
            <div class="header-search">
                <a-input-search
                    placeholder="输入搜索内容"
                />
            </div>
        </div>
        <div class="content">
            <div class="content-what">
                <p>商河三农</p>
                <p>商河——中国民间艺术之乡，鼓子秧歌的发源地，地处山东省西北部，是省会济南市的郊区县。全县总面积1162平方公里，耕地面积107万亩，下设11个乡镇、1个街道办事处、947个行政村和15个居委会。人口61万，其中农业人口52.52万。属暖温带半湿润季风气候，四季分明、光照充足，气候宜人，土地肥沃，具有丰富的石油、天然气、地热和电力资源。商河县交通非常便利，是黄河以北重要的物流中心和农产品集散地。粮棉产量在全国“双百强县”中分别列第26位和第17位，是国务院命名的秸秆养牛"十佳"示范县和全国山羊板皮出口基地县。</p>
            </div>
            <div class="content-whats">
                <div class="content-whats-title">
                    <p>六大产业</p>
                    <p>Farm Service Information</p>
                </div>
                <div class="content-whats-pro">
                    <div class="content-pro-left">
                        <div>
                            <p>{{ title }}概况</p>
                            <p>{{ text }}</p>
                        </div>
                    </div>
                    <div class="content-pro-right">
                        <div class="content-pro-right-b" @click="handleClick(0)">
                            <div><span class="icon iconfont iconpinzhiyuanliang"></span></div>
                            <p>品质原粮</p>
                        </div>
                        <div class="content-pro-right-b" @click="handleClick(1)">
                            <div><span class="icon iconfont iconwenquanhuahui"></span></div>
                            <p>温泉花卉</p>
                        </div>
                        <div class="content-pro-right-b" @click="handleClick(2)">
                            <div><span class="icon iconfont iconjingzhishucai"></span></div>
                            <p>精致果蔬</p>
                        </div>
                        <div class="content-pro-right-b" @click="handleClick(3)">
                            <div><span class="icon iconfont iconyouzhidasuan"></span></div>
                            <p>优质大蒜</p>
                        </div>
                        <div class="content-pro-right-b" @click="handleClick(4)">
                            <div><span class="icon iconfont iconlvsexumu"></span></div>
                            <p>绿色畜牧</p>
                        </div>
                        <div class="content-pro-right-b" @click="handleClick(5)">
                            <div><span class="icon iconfont icondaodiyaocai"></span></div>
                            <p>道地药材</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content-whats">
                <div class="content-whats-title">
                    <p>专题专栏</p>
                    <p>Information News</p>
                </div>
                <div class="content-whats-news">
                    <a-tooltip v-for="(item, i) in cardList" :key="i">
                        <template #title>建设中</template>
                        <a-card hoverable class="content-whats-news-card">
                            <template #cover>
                                <span class="content-whats-news-card-text">{{ item.name }}</span>
                                <img alt="example" src="../../assets/img/portal_home_test0.png" />
                            </template>
                            <a-card-meta>
                                <template #description><a-button size="large">进入专题</a-button></template>
                            </a-card-meta>
                        </a-card>
                    </a-tooltip>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Header from '@/components/portal/Header'
import { ref } from 'vue'
export default {
    name: "SanNong",
    setup() {
        const cardList = [
            {name: '三农动态'},
            {name: '品牌农业'},
            {name: '新农村建设'},
            {name: '便民链接'},
        ]
        const word = {
            0: { title: '品质原粮', text: '整合粮食绿色高质高效创建、农业生产托管服务、水肥一体化、化肥减量增效、农机深松作业补助等涉农项目，集中精力打造5万亩品质原粮订单生产基地，落实优质强筋小麦订单生产面积5.2万亩，涉及种植大户62户、整建制村31个；发展特色玉米订单生产面积5.86万亩，涉及66个新型农业经营主体、2个整建制村。品质原粮订单回收价格均高于市场价格，实现了农业增效、农民增收。'},
            1: { title: '温泉花卉', text: '高标准推进海峡两岸温泉花卉创新园建设，建成“花城、绿城”花卉供应基地8处，成功举办第六届济南花卉园艺博览会，2020年供应节庆时令花卉600万盆。设施面积突破100万平方米，花卉生产龙头企业达到15家，年生产各类高档盆花5000多万盆，花卉苗木年产值达10亿多元，被评为省会经济圈花卉展示交流基地，稳居全省第二极。建成长江以北最大的红掌基地，全国最大的红玉珠基地和全球最大单体兰花基地。同时，成立商河花卉专家科技创新团队，聘请首席专家建立红掌蝴蝶兰（48个）种植资源库，研发新品种，增强产品竞争力；支持企业发展种苗组培繁育，培植种苗组培企业2家，种苗繁育企业2家，年供应各类种苗2000多万株。\n'},
            2: { title: '精致果蔬', text: '设施蔬菜产业。新增设施蔬菜面积5200亩，认定蔬菜标准园6个，新增年育苗能力1亿株龙头企业两家，成立了由93家会员单位参加的商河县农产品协会，有力地推动了全县特色蔬菜产业发展进步。改建扩建郑路珍珠红西瓜产业园，新建成36个连片高标准温室大棚及路网、桥梁、绿化、给排水配套设施。甘薯产业面积4000亩，引进了济南吉鑫生物有限公司和济南壹亩地瓜有限公司，建成壹亩地瓜集运加工中心和怀仁镇农产品物流交易中心，打造蓝腾甘薯育苗基地。'},
            3: { title: '优质大蒜', text: '大蒜产业。白桥镇成功入选国家产业强镇创建名单，投资1.6亿元着力建设商河县大蒜新旧动能转换示范园区，实现当年开工建设，当年完成建设，当年投入使用，年消化大蒜8万吨，实现年销售额6.5亿元。'},
            4: { title: '绿色畜牧', text: '农牧互补，畜牧生产取得实效。2020年新建生猪养殖场5家，年存栏20万只蛋鸡养殖场1处，年出栏800万只肉鸡养殖场1处，截止第三季度，生猪存栏22.62万头，出栏18.93万头；牛存栏3.27万头，出栏1.2万头；羊存栏6.99万头，出栏1.72万头，禽存栏336.42万只，出栏1105.74万只，肉类总产量3.67万吨，禽蛋总产1.77万吨，奶类产量9.25万吨。\n'},
            5: { title: '道地药材', text: '道地药材产业，全县道地药材种植面积1.5万亩，500亩以上生产基地达到7个，其中新增留兰香5000亩，总面积达到8100亩，建成全国最大的连片种植基地，与“独角兽企业”华熙生物企签约合作。'},
        }
        const text = ref(word[0].text)
        const title = ref(word[0].title)
        return {
            cardList,
            title,
            text,
            word
        }
    },
    methods: {
        handleClick(i) {
            this.title = this.word[i].title
            this.text = this.word[i].text
        }
    },
    components: {
        Header
    }
}
</script>

<style scoped lang="stylus">
    .page {
        width 100%
        height 100%
        position relative
        font-size 16px
        background-color #FFF
        .header {
            width 100%
            height 730px
            padding-top 130px
            box-shadow 0 23px 120px rgba(0, 0, 0, 0.3)
            //background-color #167ADA
            border-bottom-left-radius 315px
            border-bottom-right-radius 315px
            background-image url("../../assets/img/portal_sannong_bg.png")
            background-size 100% 100%
            background-repeat no-repeat
            //background-position-y 130px
            .header-search {
                width 600px
                height 70px
                margin 200px auto
            }
            .header-search >>> .ant-input-affix-wrapper {
                height 70px
                font-size 22px
            }
            .header-search >>> .ant-input-affix-wrapper > input.ant-input {
                border-radius 5.333vw
                font-size 18px
                padding 4px 20px
            }
            .header-search >>> .ant-input-affix-wrapper .ant-input-suffix {
                margin-right 10px
            }
        }
        .content {
            width 100%
            min-height 200px
            .content-what {
                width 100%
            }
            .content-what p:first-child {
                text-align center
                font-size 55px
                color #167ADA
                font-weight bold
                margin 30px
            }
            .content-what p:last-child {
                padding 0 180px
                font-size 32px
                color #262626
                text-indent 64px
            }
            .content-whats {
                width 100%
                margin 40px 0
                .content-whats-news {
                    width 100%
                    padding 0 110px
                    display flex
                    justify-content space-evenly
                    .content-whats-news-card {
                        width 20%
                        position relative
                        .content-whats-news-card-text {
                            width 100%
                            text-align center
                            font-size 42px
                            color #FFF
                            font-weight bold
                            position absolute
                            top 100px
                            left 0
                        }
                    }
                    .content-whats-news-card >>> .ant-card-meta-description {
                        text-align center
                    }
                    .content-whats-news-card >>> .ant-btn {
                        width 230px
                        height 50px
                        line-height 50px
                        font-size 24px
                        border-radius 35px
                        background-color #F9CB33
                        color #FFF
                    }
                    .content-whats-news-card >>> .ant-btn:hover, .ant-btn:focus {
                        border-color #F9CB33
                    }
                }
                .content-whats-pro {
                    width 100%
                    margin-top 40px
                    background-color #167ADA
                    display flex
                    .content-pro-left {
                        width 50%
                        padding 55px 35px
                    }
                    .content-pro-left div {
                        width 635px
                        float right
                        line-height 50px
                    }
                    .content-pro-left p:first-child {
                        font-size 40px
                        color #F9CB33
                        width 100%
                        margin-bottom 60px
                    }
                    .content-pro-left p:last-child {
                        font-size 20px
                        color #FFF
                        text-indent 40px
                        width 635px
                    }
                    .content-pro-right {
                        width 50%
                        padding 55px 35px
                        display flex
                        flex-wrap wrap
                        justify-content space-evenly
                        .content-pro-right-b {
                            width 172px
                            font-size 36px
                            text-align center
                            color #FFF
                            margin-left 50px
                            margin-bottom 100px
                            cursor pointer
                        }
                        .content-pro-right-b div {
                            width 100%
                            height 172px
                            line-height 172px
                            text-align center
                            border-radius 50%
                            border 5px solid #FFF
                            margin-bottom 44px
                            transition .2s
                        }
                        .content-pro-right-b div:hover {
                            transform scale(1.1)
                        }
                        .content-pro-right-b div .iconfont {
                            font-size 100px
                        }
                    }
                }
            }
            .content-whats-title {
                width 100%
                text-align center
                margin-bottom 35px
            }
            .content-whats-title p:first-child {
                font-size 46px
                color #000
                font-weight bold
            }
            .content-whats-title p:last-child {
                font-size 35px
                color #CECECE
            }
        }
    }
</style>